<div class="container" dir="rtl">
  <div class="container">
    <div class="col-12">
      <div class="my-4">
        <p class="text-center "></p>
        <canvas id="myChart1" style="max-height: 750px !important"></canvas>
      </div>
    </div>
  </div>
</div>
